import GraphTabs from 'graph-tabs';
const tabs = new GraphTabs('reviews');
